module.exports = new __parcel__URL__("discovery-icon.d596fa4f.svg").toString();